import { MissingReason, EstimateLine, EstimateSummary } from "./types";
import styles from "./index.module.scss";

export const formatMissingSkuMessage = (reasons: MissingReason[]): string => {
  if (reasons.includes("itemModel")) {
    return "item model not assigned in Item Configuration";
  }
  const parts: string[] = [];
  if (reasons.includes("weight")) parts.push("weight");
  if (reasons.includes("dimensions")) parts.push("dimensions");
  if (parts.length === 0) return "missing data";
  if (parts.length === 1) return `missing ${parts[0]}`;
  return `missing ${parts.join(" and ")}`;
};

export const hasMissingWeightData = (
  missing: EstimateSummary["missing"],
  lines: EstimateLine[],
) =>
  missing.some(
    (item) =>
      item.reasons.includes("weight") || item.reasons.includes("itemModel"),
  ) || lines.some((line) => line.missingWeight || line.missingItemModel);

export const hasMissingDimensionData = (
  missing: EstimateSummary["missing"],
  lines: EstimateLine[],
) =>
  missing.some(
    (item) =>
      item.reasons.includes("dimensions") || item.reasons.includes("itemModel"),
  ) || lines.some((line) => line.missingDimensions || line.missingItemModel);

export const isIncompleteZero = (value: number, hasMissing: boolean) =>
  hasMissing && value === 0;

export const IncompleteZero = ({ decimals }: { decimals: number }) => (
  <span className={styles.incompleteZero}>{(0).toFixed(decimals)}</span>
);

export const formatShippingAddress = (
  address: Record<string, string> | null | undefined,
) => {
  if (!address?.addr1 && !address?.addr2 && !address?.city) {
    return <div>-</div>;
  }

  return (
    <div>
      {address?.addr1 && <div>{address.addr1}</div>}
      {address?.addr2 && <div>{address.addr2}</div>}
      {address?.city && (
        <div>
          {address.city}, {address.state} {address.postalCode}
        </div>
      )}
      {address?.country && <div>{address.country}</div>}
    </div>
  );
};

